let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");
// let ProOnly = require("../../../../widgets/ProOnly");
let FormUtils = require("../../../../../utils/FormUtils");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let createStandardEventForm = require("../../createStandardEventForm");

module.exports = createStandardEventForm({

  eventToInitialValues(event) {
    return {
      bureauID: event.bureauID > 0 ? event.bureauID : null,
      bureauNotes: _.get(event, ["bureauNotes"], "")
    };
  },
  buildSchema({Displaylists, is_limited_speaker, event}, data) {

    let schema = {
      bureauID: {
        label: AuthedUserSession.is_st_family ? "PD Rep" : "Bureau",
        type: "select",
        placeholder: "none -- direct",
        validate: FormUtils.v.optional,
        options: _.object(_.map(_.slice(_.get(Displaylists, "universal.bureaus"), 0, 1500), function (bureau) {
          return [bureau.bid, bureau.bname];
        }))
      },
      bureauNotes: {
        type: "text",
        label: AuthedUserSession.is_st_family ? "Sales Rep" : "Bureau Notes"
      }
    };

    //TEAM ADMIN style
    if (AuthedUserSession.is_st_family) {
      let options = _.get(Displaylists, ["universal", "eusers", event.companyID]);
      let pd_options = _.filter(options, function (o) {
        return (_.get(o, "flags", 0) & 1);
      });
      let sales_options = _.filter(options, function (o) {
        return (_.get(o, "flags", 0) & 2);
      });
      pd_options = _.map(_.sortBy(pd_options, 'name'), function (o) {
        return [o.id, o.name];
      });
      sales_options = _.map(_.sortBy(sales_options, 'name'), function (o) {
        return [o.id, o.name];
      });

      schema = {
        bureauID: {
          label: "PD Rep",
          type: "select",
          placeholder: "none -- direct",
          validate: FormUtils.v.optional,
          options: _.object(pd_options)
        },
        bureauNotes: {
          label: "Sales Rep",
          type: "select",
          placeholder: "none -- direct",
          validate: FormUtils.v.optional,
          options: _.object(sales_options)
        }
      };
    }


    return schema;
  },
  writeInputDataToEvent(data, event) {
    event.bureauID = esUtils.toInt(data.bureauID);
    event.bureauNotes = data.bureauNotes;
  },
  renderFields() {
    // let {event} = this.props;
    // return ProOnly({sids: event.sids}, ezHorizontalFields(this));
    // allow everyone to edit the bureau 01/19/18 - redheadedstep
    return ezHorizontalFields(this);
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/Bureau.js